/**
 * Netto z ceny brutto (taxes included) + stawka VAT kraju rynku.
 */
(function (global) {
  'use strict';

  var rulesCache = null;
  var EU_OPEN = { FI: 1, HR: 1, CZ: 1, SK: 1, IT: 1, IE: 1, GR: 1, ME: 1 };

  function cfgEl() {
    return document.getElementById('kayer-vat-config');
  }

  function getConfig() {
    var el = cfgEl();
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function defaultRate(cc) {
    var m = { FI: 23, HR: 25, CZ: 21, SK: 23, IT: 22, IE: 23, GR: 24, ME: 21, PL: 23 };
    return m[(cc || 'PL').toUpperCase()] || 23;
  }

  function loadRules() {
    if (rulesCache) return Promise.resolve(rulesCache);
    var cfg = getConfig();
    var url = cfg.rules_url;
    if (!url) {
      rulesCache = { countries: {} };
      return Promise.resolve(rulesCache);
    }
    return fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (j) {
        rulesCache = j;
        return j;
      })
      .catch(function () {
        rulesCache = { countries: {} };
        return rulesCache;
      });
  }

  global.kayerVatIsEuOpenMarket = function (cc) {
    var c = (cc || '').toUpperCase().slice(0, 2);
    return c !== 'PL' && !!EU_OPEN[c];
  };

  /** VAT w cenie katalogu (sprzedawca PL) — do netto z brutto, niezależnie od rynku klienta. */
  global.kayerVatCatalogIncludedRate = function (cb) {
    loadRules().then(function (rules) {
      if (rules.catalog_vat_rate_percent != null) {
        cb(Number(rules.catalog_vat_rate_percent));
        return;
      }
      var seller = (rules.seller_country || 'PL').toUpperCase().slice(0, 2);
      var row = (rules.countries || {})[seller];
      cb(row && row.vat_rate_percent != null ? Number(row.vat_rate_percent) : 23);
    });
  };

  global.kayerVatRateForMarket = function (marketCc, cb) {
    global.kayerVatCatalogIncludedRate(cb);
  };

  global.kayerGrossToNetCents = function (grossCents, ratePct) {
    var rate = Number(ratePct) / 100;
    if (!rate || rate <= 0) return grossCents;
    return Math.round(grossCents / (1 + rate));
  };

  global.kayerVatSavingsCents = function (grossCents, ratePct) {
    var net = global.kayerGrossToNetCents(grossCents, ratePct);
    return Math.max(0, grossCents - net);
  };

  global.kayerFormatMoneyCents = function (cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  };

  function i18nBag() {
    var bag = {};
    document.querySelectorAll('script[type="application/json"]#kayer-vat-i18n').forEach(function (el) {
      try {
        Object.assign(bag, JSON.parse(el.textContent || '{}'));
      } catch (e) {}
    });
    return bag;
  }

  global.kayerVatI18n = function (key, vars) {
    var bag = i18nBag();
    var s = bag[key] || '';
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.split('{{ ' + k + ' }}').join(String(vars[k]));
      });
    }
    return s;
  };

  global.kayerVatGetMarketCc = function () {
    if (document.getElementById('kayer-cart-market')) {
      if (typeof global.kayerGetCartMarketCountryIso === 'function') {
        return global.kayerGetCartMarketCountryIso();
      }
    }
    var cfg = getConfig();
    return (cfg.market_iso || 'PL').toUpperCase().slice(0, 2);
  };
})(typeof window !== 'undefined' ? window : this);
